var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c("h2", [
            _vm._v(
              "Winfakt " + _vm._s(_vm.$ct("common.tiers." + _vm.plan.tier))
            ),
          ]),
          _vm._l(_vm.plan.modules, function (module) {
            return _c("p", { key: module.ModuleID, staticClass: "pay-row" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$ct("module")) +
                  " " +
                  _vm._s(_vm.$ct("common.modules." + module.ModuleID)) +
                  " "
              ),
            ])
          }),
          _c(
            "p",
            { staticClass: "pay-row" },
            [
              _vm._v(" " + _vm._s(_vm.$ct("labels.upgrade-cost")) + " "),
              _c("w-spacer"),
              _vm._v(" € " + _vm._s(_vm.upgradeCost) + " "),
            ],
            1
          ),
          _c("w-info", {
            staticClass: "mt",
            attrs: {
              text: _vm.$ct("upgrade-new-amount", {
                amount: _vm.priceWithVat,
                timestamp: _vm.activeUntill,
              }),
              "ico-lib": "fas",
              ico: "info-circle",
            },
          }),
          _vm.mandate ? _c("div") : _vm._e(),
          _c(
            "w-button",
            {
              staticClass: "mt",
              style: { width: "100%", marginTop: "40px" },
              attrs: { green: "" },
              on: {
                click: function ($event) {
                  return _vm.upgradeClicked()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.awaitingPayment,
            callback: function ($$v) {
              _vm.awaitingPayment = $$v
            },
            expression: "awaitingPayment",
          },
        },
        [_vm.awaitingPayment ? _c("app-awaiting-payment") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }